module.exports = __webpack_public_path__ + "media/images/icons/question-circle-solid-c21b0f7e71c440b7afc26b194a99649e.svg";